import React, { Component, PropTypes } from 'react';
import ButtonDefault from '../button-default/ButtonDefault.jsx';

export default class ButtonSocial extends Component {
	static propTypes = {
		buttonText: PropTypes.string.isRequired,
		handleClickProp: PropTypes.func.isRequired,
		socialNetwork: PropTypes.string.isRequired,
		id: PropTypes.string,
		buttonState: PropTypes.string,
		intl: PropTypes.object, // GG.FrontEnd.DNA.react.intl
		type: PropTypes.string,
		isDisabled: PropTypes.bool,
		showDisabled: PropTypes.bool,
		accessibleIsLoadingText: PropTypes.string
	};

	render() {
		const {
			id,
			intl,
			type,
			buttonText,
			buttonState,
			handleClickProp,
			socialNetwork,
			isDisabled,
			showDisabled,
			accessibleIsLoadingText
		} = this.props;

		return (
			<ButtonDefault
				id={id}
				intl={intl}
				type={type}
				buttonState={buttonState}
				isDisabled={isDisabled}
				showDisabled={showDisabled}
				decoratorClass={`dna-button-${socialNetwork.toLowerCase()}`}
				qaSelector={`${socialNetwork.toLowerCase()}`}
				accessibleIsLoadingText={accessibleIsLoadingText}
				handleClick={handleClickProp}>
				{ buttonText }
			</ButtonDefault>
		);
	}
}



// WEBPACK FOOTER //
// ../~/dna-button/components/button-social/ButtonSocial.jsx